import Controller from '@ember/controller';

export default class AdminDashboardController extends Controller {}
